<template>
    <div class="agency-user-setup" v-if="agencyUser">
        <data-form :title="title"
                   tag="agency-user-setup"
                   save-button-label="Save"
                   :field-model="fieldModel"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   :load-model-instance="loadModelInstance"
                   submit-success-message="User info updated"
                   submit-error-message="Error updating"/>
    </div>
</template>

<script>

import Vue from 'vue'
import AgencyUser from '@/models/AgencyUser'

/**
 * Page for a new user to setup an agency user relation
 * i.e. If they are creating a Prog Admin, Proj Man, or Owners Rep account
 * They need to setup the Company Name or Department, which is stored on the AgencyUser relation
 */
export default Vue.extend({
    name: 'AgencyUserSetup',
    props: {
        agencyUser: Object,
    },
    data () {
        return {
            fieldModel: AgencyUser,
        }
    },
    computed: {
        fieldGroups () {
            if (!this.agencyUser) {
                return [[]]
            } else if (this.agencyUser.is_owners_representative) {
                return [['company_name']]
            } else {
                return [['department']]
            }
        },
        title () {
            if (this.agencyUser.is_owners_representative) {
               return "Owner's Representative Setup"
            } else if (this.agencyUser.is_project_manager) {
                return 'Project Manager Setup'
            } else {
                return 'Account Setup'
            }
        }
    },
    methods: {
        loadModelInstance () {
            return Promise.resolve(this.agencyUser)
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'agency-user', modelInstance).then(async (response) => {
                window.location.reload()
            })
        }
    },
})

</script>

<style lang="scss">
.agency-user-setup {
    max-width: 600px;
    margin: 0 auto;

    input[type="text"] {
        max-width: 360px;
    }
}
</style>